<template>
  <a :href="bankUrl" class="m-fast-payment-system-bank">
    <img
      :src="bank.logoURL"
      :alt="bank.bankName"
      class="m-fast-payment-system-bank__logo"
    />

    <span>{{ bank.bankName }}</span>

    <f-sprite-icon
      :icon-link="$options.icons.IconArrow.id"
      class="m-fast-payment-system-bank__arrow"
    />
  </a>
</template>

<script>
import { detectApple } from '@/utils/navigator-utils';

import IconArrow from '@icons/arrow-small.svg';

export default {
  name: 'm-fast-payment-system-bank',

  icons: {
    IconArrow,
  },

  props: {
    bank: {
      type: Object,
      required: true,
    },
    qrUrl: {
      type: String,
      required: true,
    }
  },

  computed: {
    bankUrl() {
      const { schema } = this.bank;
      const host = this.qrUrl.replace(/^(https?|ftp):\/\//, '');

      return detectApple() ? `${schema}://${host}` : `intent://${host}#Intent;scheme=${schema};end`
    },
  },
};
</script>

<style lang="scss">
.m-fast-payment-system-bank {
  display: flex;
  align-items: center;
  height: 48px;
  width: 100%;
  padding: 12px 16px;
  box-shadow: inset 0 -1px 0 $gray_lu;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: $black;

  &__logo {
    width: 24px;
    height: 24px;
    margin-right: 12px;
    object-fit: cover;
  }

  &__arrow.sprite-icon {
    width: 16px;
    height: 16px;
    margin-left: auto;
    color: $gray_lu;
  }
}
</style>
